import React from 'react';

const ProductBgArrow = (props) => {
    return (
        <img src={process.env.PUBLIC_URL + '/resources/common/images/section-bkg-pattern.png'} alt='' />
    )
}

export default ProductBgArrow;